export const PRODUCT_BADGE_STATUS_OPTIONS = [
  {
    value: '',
    label: 'Select Status',
  },
  {
    value: 'active',
    label: 'Active',
  },
  {
    value: 'inactive',
    label: 'Inactive',
  },
]

export const PRODUCT_BADGES_TABLE_COLUMNS = [
  {
    key: 'badge_name',
    label: 'Product Badge',
    headerStyle: 'min-w-200px',
    isSorted: true,
  },
  {
    key: 'tag_label',
    label: 'Display Name',
    headerStyle: 'min-w-200px',
    isSorted: true,
  },
  {
    key: 'total_product_count',
    label: 'Product Count',
    headerStyle: 'min-w-150px',
    isSorted: true,
  },
  {
    key: 'is_active',
    label: 'Status',
    headerStyle: 'min-w-100px',
    isSorted: true,
  },
  {
    key: 'action',
    label: 'Action',
    headerStyle: 'w-80px text-center',
    isSorted: false,
  },
]

export const CREATE_PRODUCT_BADGE_DEFAULT_VALUES = (isEdit: boolean, badge: any) => ({
  name: isEdit ? badge?.name : '',
  displayName: isEdit ? badge?.displayName : '',
  status: isEdit ? badge?.status?.toLowerCase() : 'active',
})
